import {
  DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_BEGIN,
  DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_SUCCESS,
  DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_FAILURE,
  DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function getSchemaForSalesforceCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionName } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/salesforce/get-schema/`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSchemaForSalesforceCollectionError() {
  return {
    type: DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_BEGIN:
      return {
        ...state,
        getSchemaForSalesforceCollectionPending: true,
        getSchemaForSalesforceCollectionError: null,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_SUCCESS:
      return {
        ...state,
        getSchemaForSalesforceCollectionPending: false,
        getSchemaForSalesforceCollectionError: null,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_FAILURE:
      return {
        ...state,
        getSchemaForSalesforceCollectionPending: false,
        getSchemaForSalesforceCollectionError: action.data.error,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        getSchemaForSalesforceCollectionError: null,
      };

    default:
      return state;
  }
}
